import React from "react";
import "./Privacy_Policy.css";
import About_Banner_Component from "../about_us/about_banner/About_Banner_Component/About_Banner_Component";
import Terms_Conditions_content from "./Privacy_Policy_content/Privacy_Policy_content";
import Privacy_Policy_content from "./Privacy_Policy_content/Privacy_Policy_content";

function Privacy_Policy() {
  return (
    <>
      <section className="Terms_Conditions">
        <About_Banner_Component
          img="\assets\Image\FAQ\banner.png"
          title="Privacy Policy"
          showBtn={false}
        />

        <Privacy_Policy_content />
      </section>
    </>
  );
}

export default Privacy_Policy;
